module.exports = {

  siteTitle: 'Nidhi Anne Sebastian | Software Developer',
  siteDescription:
    'Nidhi Anne Sebastian is a Software Developer  with 2 years of experience ,currently working at Natwest Group',
  siteKeywords:
    'Nidhi Anne Sebastian, Nidhi, Sebastian, Anne,nidhisebastian008, software developer, software engineer, java , spring , spring boot , python, java developer, django , shell scripting, hsbc, linkedin, maharaja agrasen institute of technology , pune, india, delhi, gurugram, gurgaon,natwest group, rbs , bangalore ',
  siteUrl: 'https://nidhisebastian008.github.io/',
  siteLanguage: 'en_US',
  googleAnalyticsID: 'UA-45666519-2',
  googleVerification: 'DCl7VAf9tcz6eD9gb67NfkNnJ1PKRNcg8qQiwpbx9Lk',
  name: 'Nidhi Anne Sebastian',
  location: 'Delhi, India',
  email: 'nidhisebastian008@gmail.com',
  github: 'https://github.com/nidhisebastian008',
  email: 'nidhiseb@gmail.com',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/nidhisebastian008',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/sebastiannidhi',
    },
    // {
    //   name: 'Twitter',
    //   url: 'https://twitter.com/bchiang7',
    // },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/nidhi-sebastian-6a5b91166/',
    },
    // {
    //   name: 'Codepen',
    //   url: 'https://codepen.io/bchiang7',
    // },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    // {
    //   name: 'Education',
    //   url: '/#projects',
    // },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
